/* eslint-disable eqeqeq */
import { SyncOutlined } from "@ant-design/icons";
import axios from "axios";
import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { agentSchema } from "../../components/validation/Schema";
import {
  addAgent,
  addNotification,
  loadHospitals,
} from "../../redux/admin/actions/admin.actions";
import style from "./Notification.module.scss";
import { SelectField } from "../../components/Form/SelectField";

const CreateNotification = (props) => {
  const dispatch = useDispatch();
  const { hospitals } = useSelector((state) => state.adminReducer);
  const [hospitalDropdpwn, setHospitalsDropdown] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    dispatch(loadHospitals());
    setLoading(false);
  }, [dispatch]);

  useEffect(() => {
    let options = hospitals?.map((p) => ({
      label: `${p?.name}-${p?.city}`,
      value: p?.ref_id,
    }));

    setHospitalsDropdown(options);
  }, [hospitals]);

  return (
    <>
      <Formik
        initialValues={{
          ref_id: [],
          title: "",
          message: "",
        }}
        // validationSchema={agentSchema}
        onSubmit={(values, actions) => {
          const selectedHospitals = values.ref_id.map((hosp) => hosp.value);

          values.ref_id = selectedHospitals;
          dispatch(addNotification(values, actions));
          props.onClickYes();
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleSubmit,
          isSubmitting,
          handleBlur,
          setFieldValue,
        }) => (
          <Form onSubmit={handleSubmit}>
            <h4 className=" text-center">Create Notification</h4>
            <div className={`${style.select} w-100 mt-2`}>
              <SelectField
                isMulti
                name="ref_id"
                options={hospitalDropdpwn}
                onChange={setFieldValue}
                placeholder="Select Hospitals"
                onBlur={handleBlur}
                className={`${style.formInput} basic-multi-select`}
                classNamePrefix="select"
              />
              <span className={style.counter}>
                {values?.ref_id?.length > 0 ? values?.ref_id?.length : 0}
              </span>{" "}
            </div>{" "}
            <Form.Control
              type="text"
              className={`${style.formInput} shadow-none form-control`}
              placeholder="Title"
              name="title"
              onChange={handleChange}
              onBlur={handleBlur}
              // value={values?.dispatch_id || ""}
            />
            {errors.password && touched.password ? (
              <p className={`${style.errorMessage} text-danger mt-1 mx-2`}>
                {errors.password}
              </p>
            ) : null}
            <Form.Control
              as="textarea"
              rows={4}
              className={`${style.formInput} shadow-none form-control`}
              placeholder="Message"
              name="message"
              onChange={handleChange}
              onBlur={handleBlur}
              // value={values?.dispatch_id || ""}
            />
            <div className="d-flex justify-content-center mt-3">
              <button
                type="submit"
                className={` shadow-none  ${style.actionBtn}`}
                style={{ background: props.btnColor }}
              >
                {isSubmitting ? <SyncOutlined spin /> : "SUBMIT"}
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default CreateNotification;
